import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getProjects,
  createProject,
  type ProjectCreate,
  getProjectById,
  updateProject,
} from '@shadeables/supabase';
import type { ShaderConfig } from '@shadeables/shadermodel';

export function useGetProjects() {
  return useQuery({
    queryKey: ['projects'],
    queryFn: getProjects,
  });
}

export function useCreateProject() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (newProject: ProjectCreate) => createProject(newProject),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['projects'] });
    },
  });
}

export const useProject = (id: string) => {
  return useQuery({
    queryKey: ['projects', id],
    queryFn: () => getProjectById(id),
  });
};

export function useUpdateProject() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      projectId,
      config,
    }: {
      projectId: string;
      config: ShaderConfig;
    }) => updateProject(projectId, config),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['projects', variables.projectId],
      });
      queryClient.invalidateQueries({ queryKey: ['projects'] });
    },
  });
}
